import { Box } from '@mui/material';
import { ChatConversationList } from '.';

const ChatConversationTabs = ({ conversations = [], sx = {}, ...props }) => {
  const filteredConversations = conversations.filter(
    (conversation) => !conversation.situationId
  );

  return (
    <Box {...sx}>
      <ChatConversationList conversations={filteredConversations} {...props} />
    </Box>
  );
};

export default ChatConversationTabs;
